import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import SettleList from './SettleList';

@inject('commonStore','settleStore')
@observer
class SettleContainer extends Component {

  UNSAFE_componentWillMount() {
    this.props.settleStore.setCommonStoreInfo(this.props.commonStore);
    this.props.settleStore.onClear();
    this.props.settleStore.disSettleList(1);
  }

  render() {
    const { sessionLoginInfo } = this.props.commonStore;
    return (
      <SettleList 
        cGbn={(sessionLoginInfo !== null && sessionLoginInfo.cGbn !== undefined &&  sessionLoginInfo.cGbn !== null) 
          ? sessionLoginInfo.cGbn : "" }
      />
    );
  }

}

export default withRouter(SettleContainer);
